import * as React from 'react';
import { useEffect } from 'react';

import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { screenType } from '../../../constants/enum';
import Header from '../../uiParts/Header';
import RegisterBasicCard from '../../uiParts/RegisterBasicCard';

const ClientRegisterBasic: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('title.client.registerBasic');
  });

  const handleBeforeUnloadEvent = (event: BeforeUnloadEvent): void => {
    event.returnValue = '';
  };

  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnloadEvent);
    return () =>
      window.removeEventListener('beforeunload', handleBeforeUnloadEvent);
  }, []);

  return (
    <>
      <Header />
      <Typography component="div" sx={{ marginTop: '24px' }}>
        <RegisterBasicCard screen={screenType.client} />
      </Typography>
    </>
  );
};

export default ClientRegisterBasic;
